var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.$t('seeDetails')}},[_c('BaseButton',{staticClass:"btn-link btn-github btn-simple ManageOrderButton",attrs:{"size":_vm.size,"icon":""},on:{"click":_vm.manageOrder}},[_c('i',{staticClass:"fas fa-search-plus"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }